package com.eladfinish.bible.contest.data

import dev.icerock.moko.resources.desc.StringDesc
import kotlinx.serialization.Serializable

// BookSederItem, SederInfo, VerseRef and RefRange (the sedarim.json models) live in :appContent,
// shared with the website generator.

@Serializable
data class SederData(
    val name: StringDesc,
    val start: VerseRef,
    val end: VerseRef,
)
